import MarketBill from './market-bill';

export default class MarketBillInitializeResult {
    UserId: string = '';
    Token: string = '';
    Bill: MarketBill = new MarketBill();
}